/* @ngInject */
function CampaignActionsController ($rootScope, $scope, $timeout) {
  $scope.selectedAction = null
  $scope.expirationDate = null

  const api = {
    setExpirationDate: function (date) {
      if (date) {
        $scope.expirationDate = new Date(date).toISOString()
      } else {
        $scope.expirationDate = null
      }
    }
  }

  this.getApi = () => api

  $scope.onActionSelect = (action) => {
    $scope.selectedAction = null

    $timeout(() => {
      $scope.selectedAction = action
      if (action && action.expirationDate) {
        api.setExpirationDate(action.expirationDate)
      } else {
        api.setExpirationDate(null)
      }
    })
  }
}

export { CampaignActionsController }
